import '../css/app.css';
import * as Sentry from "@sentry/react";
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { route as routeFn } from '../../../../../../vendor/tightenco/ziggy';
import { initializeTheme } from './hooks/use-appearance';

// import axios from 'axios';
// window.axios = axios;
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content') ?? null;


if(import.meta.env?.VITE_SENTRY_REACT_DSN != undefined && import.meta.env?.VITE_APP_ENV != 'local') {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_REACT_DSN,
        sendDefaultPii: true,
        environment: import.meta.env.VITE_APP_ENV ?? "staging",
    });
}

declare global {
    const route: typeof routeFn;
}

const appName = import.meta.env.VITE_APP_NAME || 'Mediální Olympiáda';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => {
        const projectPages = import.meta.glob('/resources/js/backend/pages/**/*.tsx');
        const projectPath = `/resources/js/backend/pages/${name}.tsx`;
        if (projectPages[projectPath] !== undefined) {
            return projectPages[projectPath]();
        }
        return resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx'));
    },
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on load...
initializeTheme();
